import React from 'react'
import { useTranslation } from 'react-i18next'

const LicenseBar = ({typeLicense,licenseDays}) => {
    const [t] = useTranslation('global')
    return (
        <>
            <span className="px-1 font-bold">{t('notifications.warning')}</span>
            { 
                typeLicense === 'Trail' ?
                <span>{t('notifications.trialMessage')}</span> :
                <span>{t('notifications.licenseMessage')}</span>
            }
            <span className='px-1 font-bold'>{licenseDays}</span>
            <span>{t('notifications.days')}</span>
        </>
    )
}

export default LicenseBar
